import React from "react"
import { useBreakpoint } from "gatsby-plugin-breakpoints"
import { Grid, makeStyles, Typography } from "@material-ui/core"
import { Instagram } from "@material-ui/icons"
import { StaticImage } from "gatsby-plugin-image"
import styled, { keyframes } from "styled-components"

import { responsiveFontSize } from "../Theme"
import { INSTAGRAM_URL } from "../../constants"

const glow = keyframes`
  0%, 100% { filter: drop-shadow(0 0 0 rgba(255, 255, 255, 0)); }
  50% { filter: drop-shadow(0 0 7px currentColor); }
`

const OutlinePurple = styled.span`
  font-style: italic;
  display: inline-block;
  color: #ffffff; /* 文字の色 */
  letter-spacing: 4px; /* 文字間 */
  text-shadow: 2px 2px 1px #7f007f, -2px 2px 1px #7f007f, 2px -2px 1px #7f007f,
    -2px -2px 1px #7f007f, 2px 0px 1px #7f007f, 0px 2px 1px #7f007f,
    -2px 0px 1px #7f007f, 0px -2px 1px #7f007f; /* 文字の影 */
  animation: ${glow} 3.5s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`

const useStyles = makeStyles(theme => ({
  headerTop: {
    background: "linear-gradient(to bottom, navy, maroon 60%)",
    padding: "1.2rem",
  },
  headerTxt: {
    color: "white",
    display: "inline",
    ...responsiveFontSize(theme, {
      base: "1.1rem",
      sm: "1.8rem",
      md: "2.4rem",
    }),
  },
}))

const Header = () => {
  const classes = useStyles()
  const breakpoints = useBreakpoint()

  return (
    <header>
      <Grid container direction="column">
        <Grid
          item
          container
          className={classes.headerTop}
          justifyContent="space-around"
          alignItems="center"
        >
          <Grid item style={{ textAlign: "center" }} xs={10}>
            <Typography variant="body1" className={classes.headerTxt}>
              <OutlinePurple>『カラーの魔術師』</OutlinePurple>
              は、
            </Typography>
            {breakpoints.xs ? (
              <StaticImage
                placeholder="blurred"
                src="../../images/bighead_txt.png"
                alt="BIGHEAD"
                height={16}
              />
            ) : breakpoints.sm ? (
              <StaticImage
                placeholder="blurred"
                src="../../images/bighead_txt.png"
                alt="BIGHEAD"
                height={18}
              />
            ) : breakpoints.md ? (
              <StaticImage
                placeholder="blurred"
                src="../../images/bighead_txt.png"
                alt="BIGHEAD"
                height={22}
              />
            ) : (
              <StaticImage
                placeholder="blurred"
                src="../../images/bighead_txt.png"
                alt="BIGHEAD"
                height={26}
              />
            )}
            <Typography variant="body1" className={classes.headerTxt}>
              における
              <br className="sp" />
              カラー施術コンセプトです。
            </Typography>
          </Grid>
          <Grid item xs={2} style={{ textAlign: "center" }}>
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagramギャラリー(新しいタブで開きます)"
            >
              <Instagram style={{ color: "white", fontSize: "3rem" }} />
            </a>
          </Grid>
        </Grid>
      </Grid>
      <div className="sp-block">
        <StaticImage
          src="../../images/sp_header.png"
          alt="カラーの魔術師"
          placeholder="blurred"
          layout="fullWidth"
        />
      </div>
      <div className="pc-block">
        <StaticImage
          src="../../images/pc_header.png"
          alt="カラーの魔術師"
          placeholder="blurred"
          layout="fullWidth"
        />
      </div>
    </header>
  )
}

export default Header
